import { render, staticRenderFns } from "./iDSSnackBar.vue?vue&type=template&id=2b84b0f9"
import script from "./iDSSnackBar.vue?vue&type=script&lang=js"
export * from "./iDSSnackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports